
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5xx0W", function(module, exports) {

$parcel$export(module.exports, "appendRandomRoomsTotal", () => $5a7ff4d00474c26f$export$709115c8379fd9f3);
$parcel$export(module.exports, "updateGizmoDisplay", () => $5a7ff4d00474c26f$export$4fe0a5876551879a);
$parcel$export(module.exports, "closeLoadingPopup", () => $5a7ff4d00474c26f$export$c11060a5c5fa71bc);
$parcel$export(module.exports, "openLoadingPopup", () => $5a7ff4d00474c26f$export$73bfebd7751270ab);
$parcel$export(module.exports, "enableStartGameButton", () => $5a7ff4d00474c26f$export$a342e750ee1120c9);
$parcel$export(module.exports, "updateSongInfo", () => $5a7ff4d00474c26f$export$46e34dfcee30ebb1);
$parcel$export(module.exports, "musicIsMuted", () => $5a7ff4d00474c26f$export$ac65d79a7a9f3b54);
$parcel$export(module.exports, "musicIsStopped", () => $5a7ff4d00474c26f$export$d2fa0917103cdf50);
$parcel$export(module.exports, "musicVolume", () => $5a7ff4d00474c26f$export$6b637599c0fa455f);
$parcel$export(module.exports, "showPauseButton", () => $5a7ff4d00474c26f$export$83e7e4fdf56c290b);
$parcel$export(module.exports, "showPlayButton", () => $5a7ff4d00474c26f$export$936c64f69b5cd01f);
function $5a7ff4d00474c26f$var$startGame() {
    const welcome = document.getElementById("welcome");
    if (welcome != null) {
        welcome.style.display = "none";
        window.engine.startMusic();
    }
}
function $5a7ff4d00474c26f$var$toggleInfo() {
    const button = document.getElementById("infotoggle");
    const overlay = document.getElementById("overlay");
    const info = document.getElementById("info");
    if (button != null && overlay != null && info != null) {
        if ($5a7ff4d00474c26f$var$hasClass(overlay, "hidden")) {
            button.innerText = "Show instructions";
            $5a7ff4d00474c26f$var$removeClass(info, "visible");
            $5a7ff4d00474c26f$var$addClass(info, "hidden");
            $5a7ff4d00474c26f$var$removeClass(overlay, "hidden");
            $5a7ff4d00474c26f$var$addClass(overlay, "visible");
        } else {
            button.innerText = "Hide instructions";
            $5a7ff4d00474c26f$var$removeClass(overlay, "visible");
            $5a7ff4d00474c26f$var$addClass(overlay, "hidden");
            $5a7ff4d00474c26f$var$removeClass(info, "hidden");
            $5a7ff4d00474c26f$var$addClass(info, "visible");
        }
    }
}
function $5a7ff4d00474c26f$export$709115c8379fd9f3(amount) {
    const counts = document.getElementById("roomCount");
    if (counts != null && counts.textContent != null) {
        let oldText = counts.textContent.trim();
        if (oldText.length > 0) oldText += ", ";
        counts.textContent = oldText + amount.toString();
    }
}
function $5a7ff4d00474c26f$export$4fe0a5876551879a(output) {
    const gizmo = document.getElementById("gizmo");
    if (gizmo != null) gizmo.textContent = output;
}
function $5a7ff4d00474c26f$export$c11060a5c5fa71bc() {
    const loadingPopup = window.document.getElementById("loader");
    if (loadingPopup != null) {
        loadingPopup.style.display = "none";
        window.engine.startMusic();
    }
}
function $5a7ff4d00474c26f$export$73bfebd7751270ab() {
    const loadingPopup = window.document.getElementById("loader");
    if (loadingPopup != null) loadingPopup.style.display = "flex";
}
function $5a7ff4d00474c26f$export$a342e750ee1120c9() {
    const welcomePopup = window.document.getElementById("welcome");
    if (welcomePopup != null && welcomePopup.checkVisibility() == true) {
        const startGameButton = window.document.getElementById("startGameButton");
        startGameButton.disabled = false;
        startGameButton.innerHTML = "Play Tapestry";
    }
}
function $5a7ff4d00474c26f$export$46e34dfcee30ebb1(title) {
    const songInfo = document.getElementById("songinfo");
    if (songInfo != null) songInfo.innerHTML = title;
}
function $5a7ff4d00474c26f$var$hasClass(el, className) {
    if (el) {
        if (el.classList) return el.classList.contains(className);
        return !!el.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"));
    }
    return false;
}
function $5a7ff4d00474c26f$var$addClass(el, className) {
    if (el) {
        if (el.classList) el.classList.add(className);
        else if (!$5a7ff4d00474c26f$var$hasClass(el, className)) el.className += " " + className;
    }
}
function $5a7ff4d00474c26f$var$removeClass(el, className) {
    if (el) {
        if (el.classList) el.classList.remove(className);
        else if ($5a7ff4d00474c26f$var$hasClass(el, className)) {
            var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
            el.className = el.className.replace(reg, " ");
        }
    }
}
function $5a7ff4d00474c26f$export$ac65d79a7a9f3b54() {
    return $5a7ff4d00474c26f$var$hasClass($5a7ff4d00474c26f$var$muteButton, "is-hidden");
}
function $5a7ff4d00474c26f$export$d2fa0917103cdf50() {
    return $5a7ff4d00474c26f$var$hasClass($5a7ff4d00474c26f$var$pauseButton, "is-hidden");
}
function $5a7ff4d00474c26f$export$6b637599c0fa455f() {
    if ($5a7ff4d00474c26f$var$volumeSlider != null) {
        const volume = $5a7ff4d00474c26f$var$volumeSlider.value;
        return parseInt(volume) / 100;
    }
    return 0.5;
}
function $5a7ff4d00474c26f$export$83e7e4fdf56c290b() {
    if ($5a7ff4d00474c26f$var$playButton != null) {
        $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$pauseButton, "is-hidden");
        $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$playButton, "is-hidden");
    }
}
function $5a7ff4d00474c26f$export$936c64f69b5cd01f() {
    if ($5a7ff4d00474c26f$var$playButton != null) {
        $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$playButton, "is-hidden");
        $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$pauseButton, "is-hidden");
    }
}
const $5a7ff4d00474c26f$var$muteButton = document.getElementById("mute");
const $5a7ff4d00474c26f$var$unmuteButton = document.getElementById("unmute");
const $5a7ff4d00474c26f$var$playButton = document.getElementById("play");
const $5a7ff4d00474c26f$var$pauseButton = document.getElementById("stop");
const $5a7ff4d00474c26f$var$volumeSlider = document.getElementById("volumeSlider");
if ($5a7ff4d00474c26f$var$volumeSlider != null) $5a7ff4d00474c26f$var$volumeSlider.addEventListener("input", (event)=>{
    const volume = event.target.value;
    window.engine.setMusicVolume(parseInt(volume) / 100);
});
if ($5a7ff4d00474c26f$var$muteButton != null) $5a7ff4d00474c26f$var$muteButton.onclick = ()=>{
    window.engine.muteMusic();
    $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$muteButton, "is-hidden");
    $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$unmuteButton, "is-hidden");
};
if ($5a7ff4d00474c26f$var$unmuteButton != null) $5a7ff4d00474c26f$var$unmuteButton.onclick = ()=>{
    window.engine.unmuteMusic();
    $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$unmuteButton, "is-hidden");
    $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$muteButton, "is-hidden");
};
if ($5a7ff4d00474c26f$var$playButton != null) $5a7ff4d00474c26f$var$playButton.onclick = ()=>{
    window.engine.startMusic();
    $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$playButton, "is-hidden");
    $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$pauseButton, "is-hidden");
};
if ($5a7ff4d00474c26f$var$pauseButton != null) $5a7ff4d00474c26f$var$pauseButton.onclick = ()=>{
    window.engine.pauseMusic();
    $5a7ff4d00474c26f$var$addClass($5a7ff4d00474c26f$var$pauseButton, "is-hidden");
    $5a7ff4d00474c26f$var$removeClass($5a7ff4d00474c26f$var$playButton, "is-hidden");
};
const $5a7ff4d00474c26f$var$startGameButton = document.getElementById("startGameButton");
if ($5a7ff4d00474c26f$var$startGameButton != null) $5a7ff4d00474c26f$var$startGameButton.addEventListener("click", $5a7ff4d00474c26f$var$startGame);
const $5a7ff4d00474c26f$var$infoToggleButton = document.getElementById("infotoggle");
if ($5a7ff4d00474c26f$var$infoToggleButton != null) $5a7ff4d00474c26f$var$infoToggleButton.addEventListener("click", $5a7ff4d00474c26f$var$toggleInfo);
window.addEventListener("keydown", function(e) {
    if ([
        "Space",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(e.code) > -1) e.preventDefault();
}, false);

});


parcelRequire("5xx0W");

//# sourceMappingURL=index.84330f8a.js.map
